import { createStore, combineReducers, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunk from 'redux-thunk'
import { paymentReducer,paymentStatusReducer,statusReducer } from './reducers'

export default createStore(
    combineReducers({paymentReducer, paymentStatusReducer,statusReducer}),
    composeWithDevTools(applyMiddleware(thunk))
)
